<div class="portal-container">
  <ng-template [cdkPortalOutlet]="content$ | async"></ng-template>
</div>
